module.exports = __webpack_public_path__ + "img/4.50c4f6c9.png";